import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-dash-card-link',
  templateUrl: './dash-card-link.component.html',
  styleUrls: ['./dash-card-link.component.css']
})
export class DashCardLinkComponent implements OnInit {

  constructor() { }

  @Input() info;
  @Input() route;
  @Input() title;
  @Input() image;
  @Output() routeAction = new EventEmitter();

  ngOnInit() {
  }

  routing(value) {
   this.routeAction.emit(value);
  }

}
